import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/moderation")({
	component: ModerationLayout,
})

function ModerationLayout() {
	return <Outlet />
}
